import React from "react"
import {
	IconCheckOutline18 as Check,
	IconChevronDownOutline18 as ChevronDown,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import {
	DropdownMenu,
	DropdownMenuGroup,
	DropdownMenuItem,
} from "@productlane/ui/src/components/internal/dropdown"

import { EditorMenuButton } from "../editor-menu-button"

interface DropdownItem {
	id: string | number
	label: string
	icon?: React.ComponentType<{ className?: string }>
}

interface EditorMenuDropdownProps {
	containerRef?: React.RefObject<HTMLDivElement | null>
	items: DropdownItem[]
	activeItem: string | number | undefined
	onSelect: (id: string | number) => void
	triggerIcon: React.ComponentType<{ className?: string }>
}

export const EditorMenuDropdown: React.FC<EditorMenuDropdownProps> = ({
	containerRef,
	items,
	activeItem,
	onSelect,
	triggerIcon: TriggerIcon,
}) => {
	return (
		<DropdownMenu
			trigger={
				<div>
					<EditorMenuButton isActive={true} className="flex items-center pr-1">
						<TriggerIcon className="h-4 w-4" />
						<ChevronDown className="ml-auto h-3.5 w-3.5" />
					</EditorMenuButton>
				</div>
			}
			containerRef={containerRef}
			className="w-[173px]"
		>
			<DropdownMenuGroup>
				{items.map(({ id, label, icon: Icon }) => (
					<DropdownMenuItem
						key={id}
						onSelect={() => onSelect(id)}
						className="group w-full"
					>
						<div className="flex h-6 w-full items-center gap-2 truncate">
							{/* Icon */}
							{Icon && <Icon className="h-4 w-4 flex-none" />}

							{/* Label */}
							<div className={cn("truncate text-xs")}>{label}</div>

							{/* Active Indicator */}
							{id === activeItem && (
								<Check className="ml-auto h-4 w-4 flex-none opacity-60 transition-opacity group-hover:opacity-100" />
							)}
						</div>
					</DropdownMenuItem>
				))}
			</DropdownMenuGroup>
		</DropdownMenu>
	)
}
